import * as React from 'react';

import './UnauthenticatedSatUserMessage.scss';

export default class UnauthenticatedSatUserMessage extends React.PureComponent {
  render() {
    return (
      <div className="authentication-error onboarding">
        <div className="authentication-error__description">
          You need to log in to continue.
          <br />
          Please close this window, log in, and try again.
        </div>
      </div>
    );
  }
}
